/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.0.0
 */

/*
 * -------------------------------------------
 *           ACTIONS
 * -------------------------------------------
 */

export const MODAL_OPEN = '@@b2b_portal_ui/modal/MODAL_OPEN';
export const MODAL_RENDER = '@@b2b_portal_ui/modal/MODAL_RENDER';
export const MODAL_CLOSE = '@@b2b_portal_ui/modal/MODAL_CLOSE';
export const MODAL_CLOSE_ALL = '@@b2b_portal_ui/modal/MODAL_CLOSE_ALL';
export const MODAL_SET_STATUS = '@@b2b_portal_ui/modal/MODAL_SET_STATUS';
export const MODAL_SET_PARAMS = '@@b2b_portal_ui/modal/MODAL_SET_PARAMS';
